import { render, staticRenderFns } from "./SavedChanges.vue?vue&type=template&id=aa9aba66&"
import script from "./SavedChanges.vue?vue&type=script&lang=js&"
export * from "./SavedChanges.vue?vue&type=script&lang=js&"
import style0 from "./SavedChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports